import React, {Component} from 'react';
import ReactModal from 'react-modal';
import TerminDetail from './TerminDetail'
import config from "../config";
import {nl2br} from "../utils/Utils"
import './TerminOverlay.css'

const format = require('date-fns/format')
const de = require('date-fns/locale/de')

const TermineTeaserOrt = (props) => {
    let raum = props.raum
    let addressRow = []

    if (!raum) {
        return null
    }

    if (raum.landkreis) {
        addressRow.push('Landkreis: ' + raum.landkreis);
    }

    if (raum.ort) {
        addressRow.push('Ort: ' + raum.ort);
    }

    if (raum.name) {
        addressRow.push('Veranstaltungsort: ' + raum.name);
    }

    if (addressRow.length === 0) {
        return null
    }

    return addressRow.map(item => {
        return (
            <div className={'termin-meta-info'}>
                {item}
            </div>
        );
    });
}

const customStyles = {
    content: {
        padding: 0
    },
    overlay: {
        backgroundColor: 'transparent'
    }
};

class EventTeaser extends Component {

    constructor(props) {
        super();

        if (parseInt(props.fulltext) === parseInt(props.event.id)) {
            this.state = {
                modalIsOpen: true
            };
        } else {
            this.state = {
                modalIsOpen: false
            };
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.liRef = React.createRef();
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render() {
        let {event} = this.props;
        let month = format(new Date(event.startdatum), 'MMM', {locale: de})
        let day = format(new Date(event.startdatum), 'DD')
        let year = format(new Date(event.startdatum), 'YYYY')

        return ( 
            <li className={'termin'} key={event.id}>
                <button className="row termin-button" ref={this.liRef} onClick={this.openModal} style={{ all: 'unset', display: 'flex', width: '100%'}}>
                    <div className={'col-xs-2 col-sm-1'}>
                        <span className={'date-badge'} style={{ width: '70px'}}>
                            <span className={'tmonth'}>{month} {year}</span>
                            <span className={'tday'}>{day}</span>
                        </span>
                    </div>
                    <div className={'col-xs-10 col-sm-11'}>
                        <div className={'pl-4'}>
                            <div className={'termin-details'} style={{ marginLeft: '5px'}}>
                                <h2 className={'termin-title'}>
                                    {window.bbvTermine.admin && <a target={"_blank"} href={config.baseUrl+'/admin/veranstaltungen/'+event.id+'/edit'}><i className={'glyphicon glyphicon-pencil'} /></a>}
                                    {nl2br(event.titel)}
                                </h2>
                                <div className="vsp-1" />
                                {event.status === 2 ? <div className={'termin-meta-info alert alert-danger'}>Abgesagt</div> : <span /> }
                                {event.status === 4 ? <div className={'termin-meta-info alert alert-danger'}>Ausgebucht</div> : <span /> }
                            </div>
                            <div className={'termin-meta-block'}>
                                <TermineTeaserOrt raum={event.raum}/>
                            </div>
                        </div>
                    </div>
                </button>
                <hr/>
                <ReactModal style={ customStyles } isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} contentLabel="Example Modal" appElement={document.getElementById('biwe-termine')}>
                    <div className={'pl-4 pr-4 pb-4 pt-0'} style={{ position: 'relative' }}>
                        <div className={'sticky-top pt-4'} style={{ background: '#ffffff' }}>
                            <div className={'row'}>
                                <div className={'col-xs-2'}>
                                    <div className={'detailBbvLogo'}><img src={config.baseBbvUrl + '/themes/custom/bbv/logo.svg'} alt={'Logo des BBV'}/></div>
                                </div>
                                <div className={'col-xs-10'}>
                                    <button onClick={this.closeModal} type="button" style={{ fontSize: '35px', color: '#7b7b7b', opacity: 1 }} className={"close pl-2 pr-2 mr-2 pb-1 border rounded-circle"} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                            </div>
                            <hr/>
                        </div>
                        <TerminDetail event={event}/>
                    </div>
                </ReactModal>
            </li>
        )
    }
}

export default EventTeaser


// WEBPACK FOOTER //
// ./src/components/EventTeaser.js